const reasons = [
  {
    icon: "ri-fridge-line",
    title: "Food, Medicine & Kids",
    desc: "Lost groceries, spoiled formula, dead medical devices — when you have little ones depending on you, none of that is acceptable.",
    color: "text-red-500",
    bg: "bg-red-50",
  },
  {
    icon: "ri-home-heart-line",
    title: "Keep Your Family Safe",
    desc: "Lights, heat, fans, security systems — the things that make a house feel safe don't stop being important when the grid does.",
    color: "text-amber-500",
    bg: "bg-amber-50",
  },
  {
    icon: "ri-wifi-line",
    title: "Stay Connected & Informed",
    desc: "Phones, routers, and devices keep you in touch with loved ones and emergency services when you need information most.",
    color: "text-emerald-500",
    bg: "bg-emerald-50",
  },
  {
    icon: "ri-seedling-line",
    title: "Build Long-Term Resilience",
    desc: "Rising costs and uncertainty aren't going away. A solid backup plan today means your family is protected for years to come.",
    color: "text-indigo-500",
    bg: "bg-indigo-50",
  },
];

export default function WhyBackupPower() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight">
          We&apos;ve Seen How Fast<br />
          <span className="text-amber-500">Life Can Be Disrupted</span>
        </h2>
        <p className="text-gray-500 mt-4 max-w-2xl mx-auto text-base leading-relaxed">
          Power outages, supply disruptions, unexpected emergencies — as a family, we started asking ourselves a simple question: &ldquo;Why aren&apos;t we better prepared?&rdquo; Here&apos;s what being unprepared actually costs.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
          {reasons.map((r) => (
            <div
              key={r.title}
              className="flex flex-col items-center text-center p-6 rounded-lg border border-gray-100 hover:border-amber-200 transition-colors"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-full ${r.bg} mb-4`}>
                <i className={`${r.icon} text-2xl ${r.color}`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{r.title}</h3>
              <p className="text-gray-500 text-xs leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA callout */}
        <div className="mt-14 bg-gray-950 rounded-lg px-8 py-7 flex flex-col md:flex-row items-center justify-between gap-5 text-center md:text-left">
          <p className="text-gray-200 text-base md:text-lg font-medium max-w-xl leading-relaxed">
            The question isn&apos;t <em>if</em> you&apos;ll lose power —{" "}
            <strong className="text-amber-400">it&apos;s whether you&apos;ll be ready when it happens.</strong>
          </p>
          <a
            href="https://ironhavensupply.com/collections/home-backup-power"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 bg-amber-500 hover:bg-amber-400 text-white font-bold px-7 py-3 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            View Backup Power Systems
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-xs"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
